import { render, staticRenderFns } from "./DialogInfo.vue?vue&type=template&id=784a1ad0"
import script from "./DialogInfo.vue?vue&type=script&lang=ts"
export * from "./DialogInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports